import React from 'react';
import ContactsModule from './ContactsModule';
import { ToastContainer } from 'react-toastify';

const Result = () => {
  return (
    <>
      <ToastContainer />
      <div className="user-section">
        <ContactsModule />
      </div>
    </>
  );
};

export default Result;
